import * as Constants from "../utils/constants";
import * as ApiUtils from "./api-utils";
import { StationDefinition } from "./api-data-model";

export async function getStations(
  searchTerm: string = "",
  count?: number
): Promise<StationDefinition[]> {
  let url = ApiUtils.AppendParams(Constants.API_EP_GET_STATIONS, {
    q: searchTerm,
    count: count,
  });
  let response = await fetch(url);
  return await response.json();
}
